import LogRocket from 'logrocket'

const resolveGraphqlUrl = () => {
	const configured = (process.env.VUE_APP_GRAPHQL_SERVER || '').trim()
	if (!configured) {
		return null
	}
	try {
		const normalized = configured.startsWith('//')
			? `${window.location.protocol}${configured}`
			: configured
		return new URL(normalized)
	} catch (_e) {
		return null
	}
}

const graphqlUrl = resolveGraphqlUrl()

const isGraphqlRequest = url => {
	if (!url || !graphqlUrl) {
		return false
	}
	try {
		const parsed = new URL(url)
		return parsed.pathname === graphqlUrl.pathname &&
			(graphqlUrl.hostname === '0.0.0.0' || parsed.hostname === graphqlUrl.hostname)
	} catch (_e) {
		return false
	}
}

// Never record GraphQL bodies or auth headers: auth/MFA operations carry
// TOTP secrets, verification codes, Cognito session keys and tokens.
const sanitizeGraphqlRecord = record => {
	if (isGraphqlRequest(record.url)) {
		record.body = undefined

		if (record.headers) {
			if (record.headers.Authorization) {
				record.headers.Authorization = '[REDACTED]'
			}
			if (record.headers.Cookie) {
				record.headers.Cookie = '[REDACTED]'
			}
		}
	}
	return record
}

if (process.env.NODE_ENV === 'production') {
	LogRocket.init(process.env.VUE_APP_LOGROCKET_KEY, {
		network: {
			requestSanitizer: sanitizeGraphqlRecord,
			responseSanitizer: sanitizeGraphqlRecord
		}
	})
}
